import { useSearch } from "@tanstack/react-router";
import ChangePassword from "../components/Auth/AuthChangePassword";
import ForgotPassword from "../components/Auth/AuthForgotPassword";

export default function Forgot() {
  const { token, user_id } = useSearch({ strict: false }) as {
    token?: string;
    user_id?: string;
    email?: string;
  };

  const hasResetParams = !!token && !!user_id;

  if (hasResetParams) {
    return <ChangePassword token={token!} userId={user_id!} />;
  }

  return <ForgotPassword />;
}
